import React, { PureComponent } from 'react';
import { Dropdown, Grid } from 'semantic-ui-react';
import VegaChart from '../../common/vega/VegaChart';
import { isoTypeUstatPostgraduates } from '../../common/vega/VegaSpecifications';
import * as _ from 'lodash';
import * as dl from 'datalib';
import { getUSTATDataMaster } from './ustat-dataretriever-master';
import Preloader from '../../components/Preloader';
import { ISOTYPES_TUSCANY_UNIVERSITIES } from '../../common/constants';
import { CSVLink } from "react-csv";
import {strings} from '../../common/translations'

// dropdown options
let ustatPosgraduateOrganizationsOptions;
let noDataUstatPosgraduateOrganizationsOptions;
let ustatUniquePosgraduateOrganizationsOptions;

const getOrderOfMagnitude = function (n) {
    var order = Math.floor(Math.log(n) / Math.LN10
        + 0.000000001); // because float math sucks like that
    return Math.pow(10, order);
};

class DataVizUstatIsotypesMaster extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            ustatPostgraduateOrganizations: [],
            organizationsFilter: undefined,
            emptyData: false
        };
    }

    /**
     * Retrieve all the data to populate comboboxes and the visualization
     */
    async componentDidMount() {
        let data = await getUSTATDataMaster();

        // Translate VEGA SPEC tooltip
        isoTypeUstatPostgraduates["marks"][0]["marks"][0]["encode"]["update"]["tooltip"] = {"signal": "datum.studentType == 'iscritti' ? upper('" + strings.ALTA_FORMAZIONE.CHARTS.ISOTYPE.TOOLTIP.ISCRITTI + "') : upper('" + strings.ALTA_FORMAZIONE.CHARTS.ISOTYPE.TOOLTIP.DIPLOMATI + "') "}

        // no data for 'Università per Stranieri di Siena',
        // so exclude it
        // data = _.filter(data, o => {
        //     return o.organizationName !== 'Università per Stranieri di Siena';
        // });

        // populate dropdown options
        ustatPosgraduateOrganizationsOptions = _.map(
            _.map(_.uniqBy(data, 'organizationName'), 'organizationName'),
            (organization, index) => ({
                // key: index,
                text: organization,
                value: organization
            })
        );

        noDataUstatPosgraduateOrganizationsOptions = ISOTYPES_TUSCANY_UNIVERSITIES.map(function(organization, index) {
            return {text: organization.label, value: organization.label}
        })

        ustatUniquePosgraduateOrganizationsOptions = _.unionBy(ustatPosgraduateOrganizationsOptions, noDataUstatPosgraduateOrganizationsOptions, 'value');

        this.setState({ data: data });
    }

    render() {
        const {
            data,
            organizationsFilter,
            emptyData
        } = this.state;

        
        if (!_.isNil(data)) {
            
            let isoTypeData = _.clone(data);
            
            // filter by selected org, if any
            if (organizationsFilter)
            isoTypeData = _.filter(isoTypeData, o => o.organizationName === organizationsFilter);
            
            isoTypeData = dl.groupby(["year", "studentType"])
            .summarize([
                { 'name': 'male', ops: ['sum'], as: ['male'] },
                { 'name': 'female', ops: ['sum'], as: ['female'] },
                { 'name': 'foreignMale', ops: ['sum'], as: ['foreignMale'] },
                { 'name': 'foreignFemale', ops: ['sum'], as: ['foreignFemale'] }
            ])
            .execute(isoTypeData);

            let magnitude;
            let vegaData = [];
            if (isoTypeData.length > 0) {
                
                // sum students, take into account gender filters
                isoTypeData = _.forEach(isoTypeData, o => {
                    o.total = o.male + o.foreignMale + o.female + o.foreignFemale;
                });
    
                // get order of magnitude looking for the max total for a year
                // divide by a number just to show more icons
                magnitude = getOrderOfMagnitude(
                    _.maxBy(isoTypeData, 'total').total
                );
                magnitude = 100;
    
                // now generate data for the isotype vega chart:
                // (https://vega.github.io/vega-lite/examples/isotype_bar_chart.html)
                const years = _.map(_.uniqBy(isoTypeData, 'year'), 'year');
                const studentTypes = ['iscritti', 'diplomati'];
    
                
                years.forEach(year => {
                    let colIscritti = 0;
                    let colDiplomati = 0;
                    studentTypes.forEach(studentType => {
                        var row = _.find(
                            isoTypeData,
                            o => o.year === year && o.studentType === studentType
                        );
                        if (row) {
                            // generate, for each year and student types, as many columns as needed
                            // to reach our number of students by type,
                            var repetitions = Math.ceil(row.total / magnitude);
                            for (let i = 0; i < repetitions; i++) {
                                //col = studentType === 'diplomati'? col-1 : col+1;
                                if (studentType === 'diplomati')
                                    colDiplomati += 1;
                                else
                                    colIscritti += 1
    
                                vegaData.push({
                                    year: year,
                                    studentType: studentType,
                                    studentFlow: studentType === 'diplomati' ? 'out' : 'in',
                                    col: (studentType === 'diplomati') ? colDiplomati : colIscritti,
                                    total: row.total
                                })
                            }
                        }
                    });
                });
            } else {
                this.setState({emptyData: true})
                // return <Preloader message="Caricando i dati" />
            }
            



            return <div className="dataviz-isotypes">
                <Grid>
                    <Grid.Row className="mt-4 mb-0 pb-0">
                        <Grid.Column width={16}>
                            <Dropdown
                                placeholder={strings.ALTA_FORMAZIONE.CHARTS.ISOTYPE.SELECTOR_PLACEHOLDER}
                                search
                                selection
                                clearable
                                options={ustatUniquePosgraduateOrganizationsOptions}
                                onChange={(event, data) => {
                                    this.setState({
                                        organizationsFilter: data.value !== '' ? data.value : undefined,
                                        emptyData: false
                                    });
                                }}
                                className='dropdown-organizations'
                            />
                        </Grid.Column>
                    </Grid.Row>
                    {
                        emptyData ?
                        <div className="emptystate">{strings.COMMON.NO_DATA} - {organizationsFilter}</div>
                        :
                        <Grid.Row className="pt-0">
                            <Grid.Column>
                                <VegaChart
                                    chartClass={'isotypes'}
                                    height={500}
                                    data={vegaData}
                                    spec={isoTypeUstatPostgraduates} />
                            </Grid.Column>
                        </Grid.Row>
                    }
                    {
                        !emptyData &&
                        <Grid.Row className="border-top pt-0">
                            <Grid.Column width={16} className="d-flex flex-wrap">
                                <p className="avatars w-100">
                                    <span className="icon-type student"></span>
                                    <span className="">{strings.ALTA_FORMAZIONE.CHARTS.ISOTYPE.TOOLTIP.ISCRITTI}</span>
                                    <span className="icon-type graduated ml-4"></span>
                                    <span>{strings.ALTA_FORMAZIONE.CHARTS.ISOTYPE.TOOLTIP.DIPLOMATI}</span> 
                                    <small className="text-muted d-inline-block ml-4">{strings.formatString(strings.ALTA_FORMAZIONE.CHARTS.ISOTYPE.LEGEND, <strong className="avatarValue">{magnitude}</strong>)}</small>
                                </p>
                                <CSVLink data={data} 
                                         className="ui red circular icon button mx-auto"
                                         filename={"studentiMasterToscana.csv"}>
                                             <i aria-hidden="true" className="download icon"></i>
                                </CSVLink>
                            </Grid.Column>
                        </Grid.Row>
                    }
                </Grid>
            </div>
        }
        else
            return <Preloader message={strings.COMMON.LOADING_DATA} />
    }
}
export default DataVizUstatIsotypesMaster;